// The IT apps checklist pieces the Connected apps tab places around its
// Google groups (spec §4.3): the leaver banner, the two open groups, and the
// load-failure notice. The rows themselves render inside AppGroups so resolved
// items share the existing Closed disclosure.
import { leaverBanner } from './checklist';

export const IT_GROUPS = [
  { key: 'close-manually', label: 'Close manually', field: 'closeManually' },
  { key: 'remove-seat', label: 'Remove paid seat', field: 'removeSeat' },
];

// Open groups for AppGroups, in fixed order; empty ones are dropped there.
export const itGroupDefs = (split) => IT_GROUPS.map((g) => ({ key: g.key, label: g.label, items: split[g.field] || [] }));

export function LeaverBanner({ leaver }) {
  const text = leaverBanner(leaver);
  if (!text) return null;
  const tone = leaver.status === 'leaving_soon' ? 'ca-leaver--soon' : 'ca-leaver--left';
  return <p className={`ca-leaver ${tone}`}>{text}</p>;
}

// The second sentence is only true when the Google list actually loaded.
export function ItChecklistError({ googleLoaded = false }) {
  return (
    <p className="ca-note ca-note--error">
      Couldn&apos;t load the IT apps checklist.{googleLoaded ? ' Google apps below are still up to date.' : ''}
    </p>
  );
}
